import React, { useEffect, useState } from 'react'
import { CardBody, Col, Form, FormGroup, Label, Row } from 'reactstrap';
import { NineDay, Save, SixDay, ThreeDay, } from '../../../Constant';
import { Btn } from '../../../AbstractElements';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { getRewardRate, getRewardRateRole, postRewardRate, postRewardRateRole } from '../../../CommonUrl';

const ApplicationForm = () => {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const authState = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const isReadOnly = authState.userRole !== 1;

    useEffect(() => {
        getDeliveryData();
    }, []);

    const getDeliveryData = async () => {
        setLoading(true);
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRewardRate : getRewardRateRole);
        if (data.status === true) {
            const customerAppArray = data?.data;
            customerAppArray.map((e) => {
                if (e.type === 'customer_app') {
                    setValue('appThree', e?.thirty);
                    setValue('appSix', e?.sixty);
                    setValue('appNine', e?.ninety);
                }
            })
        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    }


    const onSubmit = async (data) => {
        setLoading(true);
        const customerApp = [
            {
                type: 'customer_app',
                thirty: data?.appThree,
                sixty: data?.appSix,
                ninety: data?.appNine
            }
        ];
        const postRequest = {
            reward_percentage: customerApp,
        }
        const addAreaResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? postRewardRate : postRewardRateRole, postRequest);
        if (addAreaResponse.status === 200) {
            if (addAreaResponse.data.status === true) {
                getDeliveryData();
                toast.success(addAreaResponse.data.message);
            } else {
                toast.error(addAreaResponse.data.message)
                setLoading(false);
            }
        } else if (addAreaResponse.status >= 400 && addAreaResponse.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (addAreaResponse.status >= 500 && addAreaResponse.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
        setLoading(false);
    };
    return (
        <CardBody>
            <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="appThree">{ThreeDay}</Label>
                        <input className="form-control" id="appThree" type="text" readOnly={isReadOnly}
                            {...register('appThree')}
                        />
                    </Col>
                    <Col md='6'>
                        <Label className="form-label" for="appSix">{SixDay}</Label>
                        <input className="form-control" id="appSix" type="text" readOnly={isReadOnly}
                            {...register('appSix')}
                        />
                        <p className="text-danger">{errors.sku?.message}</p>
                    </Col>
                </Row>
                <Row className="g-3 pt-3">
                    <Col md='6'>
                        <Label className="form-label" for="appNine">{NineDay}</Label>
                        <input className="form-control" id="appNine" type="number" min="0" readOnly={isReadOnly}
                            {...register('appNine')}
                        />
                    </Col>
                </Row>
                <FormGroup>
                </FormGroup>
                <Btn attrBtn={{ color: "primary" }} type="submit">{Save}</Btn>
            </Form>
        </CardBody>
    )
}

export default ApplicationForm